import type { TFunction } from "i18next";

/** "vừa xong" / "5 phút trước"… từ Unix giây; quá 7 ngày thì hiện ngày. */
export function formatRelative(unixSec: number, t: TFunction): string {
  if (!unixSec) return "-";
  const d = new Date(unixSec * 1000);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return t("vừa xong");
  if (diff < 3600) return t("{{n}} phút trước", { n: Math.floor(diff / 60) });
  if (diff < 86400) return t("{{n}} giờ trước", { n: Math.floor(diff / 3600) });
  if (diff < 86400 * 7)
    return t("{{n}} ngày trước", { n: Math.floor(diff / 86400) });
  return d.toLocaleDateString();
}

export function themeLabel(mode: number, t: TFunction): string {
  switch (mode) {
    case 0:
      return t("Street");
    case 1:
      return t("Light");
    case 2:
      return t("Dark");
    case 3:
      return t("Hybrid");
    default:
      return String(mode);
  }
}
